import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type ClubRatingDto = {
  artistProfileId: string;
  clubRatingId: number;
  workRequestId: number | null;
  workInviteId: number | null;
  clubProfileId: number;
  staffAndManagement: number;
  dressingRoom: number;
  housing: number;
  comment: string | null;
  reply: string | null;
  createdAt: string;
};

export type GetClubRatingsRequest = {
  clubId: number;
  artistProfileId: number;
  pageNumber?: number;
  pageSize?: number;
};

export type GetClubRatingsParams = RequestConfig<GetClubRatingsRequest>;

export const getClubRatings = async ({
  params,
  config
}: GetClubRatingsParams) =>
  api.get<{
    items: ClubRatingDto[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  }>(`/api/ratings/club/ratings`, {
    ...config,
    params: {
      clubId: params.clubId,
      artistProfileId: params.artistProfileId,
      pageNumber: params.pageNumber ?? 1,
      pageSize: params.pageSize ?? 10
    }
  });
